/* src/app/dialogs/relation-picker/relation-picker.component.css */
.d-flex {
  margin-bottom: 10px;
  margin-top: 10px;
}
.d-flex p {
  margin: 0px;
}
.mat-mdc-card-title {
  margin-right: 20px;
}
.row > div > mat-card {
  margin-bottom: 15px;
}
.article-card mat-card-content {
  height: 400px;
  display: flex;
  flex-direction: column;
}
mat-tab mat-card-content > .imageBox {
  flex: 1 0 0;
  display: flex;
  min-height: 0;
}
mat-tab mat-card-content > .imageBox > img {
  max-width: 100%;
  margin: auto;
}
.info {
  margin-top: -8px;
  display: block;
  position: absolute;
  right: 10px;
}
.newBox {
  height: 30px;
  margin-top: -40px;
}
.new {
  background-color: #ff4081;
  color: white;
  font-size: 20px;
  animation-name: pulse;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  position: absolute;
  right: 10px;
}
.imageBox {
  height: 350px;
  overflow: hidden;
  text-align: center;
}
.imageBox:before {
  content: "";
  display: inline-block;
  height: 350px;
  vertical-align: middle;
}
.imageBox img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}
button.mat-mdc-icon-button {
  width: 24px;
  height: 24px;
  margin-top: -10px;
  border-radius: 50%;
}
@keyframes pulse {
  0% {
    padding: 5px;
  }
  50% {
    padding: 7px;
  }
  100% {
    padding: 5px;
  }
}
/*# sourceMappingURL=relation-picker.component-MGSJ7CQ4.css.map */
